export const backgroundsConfig = {
  default: 'Light',
  values: [
    {
      name: 'Light',
      value: '#FFF',
    },
    {
      name: 'Dark',
      value: '#181f36',
    },
  ],
};
export const withDarkBackground = { backgrounds: { default: 'Dark' } };

const cdnUrls = {
  it: 'https://cdn.freedome.it',
  es: 'https://cdn.freedome.eu',
};

export const CDN_BASE_URL = cdnUrls[freedomeConfig.baseLocale];
export const brandImageLight = `${CDN_BASE_URL}/icons/freedome-full-logo-light.svg`;
export const brandImageDark = `${CDN_BASE_URL}/icons/freedome-full-logo-dark.svg`;
